module.exports = __webpack_public_path__ + "img/51_BF29_bored_talk_about_the_weather.7fde84c8.jpg";